import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAppInitializer } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { globalErrorInterceptor } from '../http-interceptors/global-error-interceptor';
import { DialogModule } from '../modules/ui/dialog/dialog.module';
import { MobilePopoverModule } from '../modules/ui/mobile-popover/mobile-popover.module';
import { SharedModule } from '../shared/shared.module';
import { CollectionModule } from '../modules/ui/collection/collection.module';
import { MfeUtilsService } from '@shared/services/MFE/mfe-utils.abstract.service';
import { StandaloneMfeUtilsService } from '@shared/services/MFE/standalone-mfe-utils.service';
import { ToastStandaloneService } from '@app/shared/services/toast/toast-standalone.service';
import { ToastService } from '@app/shared/services/toast/toast.abstract.service';
import { AppRunService } from '@app/app-run';
import { BrowserModule } from '@angular/platform-browser';
import { initializePublicApp } from './initializers/public.initializer';
import { authState } from '@app/modules/auth/auth.state';
import { jobShareState } from '@app/modules/job-share-list/job-share.state';
import { legalTermsState } from '@app/modules/legal-terms/legal-terms.state';
import { notFoundState } from '@app/modules/not-found/not-found.state';
import { referralState } from '@app/modules/referral/referral.state';

export const publicApplicationConfig: ApplicationConfig = {
  providers: [
    { provide: 'APP', useValue: 'public' },
    provideAppInitializer(() => initializePublicApp()),
    provideHttpClient(withInterceptors([globalErrorInterceptor])),
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    {
      provide: MfeUtilsService,
      useClass: StandaloneMfeUtilsService
    },
    {
      provide: ToastService,
      useClass: ToastStandaloneService
    },
    AppRunService,
    importProvidersFrom(
      BrowserModule,
      CollectionModule,
      DialogModule,
      MobilePopoverModule,
      SharedModule,
      UIRouterModule.forRoot({
        states: [legalTermsState, ...authState, ...jobShareState, ...referralState, notFoundState],
        deferIntercept: true
      })
    )
  ]
};
